// check-in ทุกนาทีของเครื่องนี้ stores/{storeId}/checkin/{computerId}/... (ดู utils/checkin.ts)
//
// เริ่มเมื่อ login firebase แล้ว และ shop.init() ผ่านการตรวจ claim จน registerModule()
// ตั้ง storeId ให้ useFirebase() แล้ว (ตัวเดียวกับที่ presence online/ ใช้)
// ไม่ต้องรอ bootstrap ทั้งคิว — เครื่องที่ boot ค้างกลางทางก็ยังนับว่าเปิดอยู่
// logout / signOut → หยุด (auth.ts เรียก stopCheckin() ก่อน signOut อีกชั้น)
import "../../../firebaseInstance";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useFirebase } from "../composables/useFirebase";
import { readComputerIdentity } from "../composables/useComputerIdentity";
import { startCheckin, stopCheckin } from "../utils/checkin";

export default defineNuxtPlugin(() => {
  const loggedIn = ref(false);
  const { storeId } = useFirebase();

  // ID อ่านสดทุกรอบ — ใช้ ID ต่อร้านก่อน ไม่มีค่อยใช้ computerUuid ของ auth store
  const getComputerId = () =>
    readComputerIdentity(storeId.value || "")?.id || useAuthStore().computerUuid || null;

  try {
    onAuthStateChanged(getAuth(), (user) => {
      loggedIn.value = !!user;
    });
  } catch (error) {
    console.warn("[checkin] ฟังสถานะ login ไม่ได้", error);
    return;
  }

  watch(
    [loggedIn, storeId],
    ([isLoggedIn, id]) => {
      if (!isLoggedIn || !id) {
        stopCheckin();
        return;
      }
      startCheckin(id, getComputerId);
    },
    { immediate: true }
  );
});
